import aiassist from "../assets/images/AIASSIST.png";
import codeassist from "../assets/images/CODEASSIST.png";
import clothing_recommender from "../assets/images/clothing_recommender.png";
import Eccomerence from "../assets/images/DASHBOARD.png";
import visualizer from "../assets/images/VISUALIZER.png";
import car from "../assets/images/car.png";
import github from "../assets/images/github.png";
import sextant from "../assets/images/SEXTANT.png";
//constants
export const projects = [
  {
    title: "Mood Tracker",
    desc: "A full-stack journaling app designed to help users track and manage their emotional well-being with AI-powered prompts, text-to-speech, and secure authentication. Built with a Next.js frontend and FastAPI backend, backed by MySQL on AWS. The frontend was deployed through AWS Amplify, the backend through AWS Elastic Beanstalk, with a CI/CD pipeline ensuring smooth deployments and 99.9% uptime.",
    tags: [
      {
        name: "Next.js",
        color: "blue-200",
      },
      {
        name: "TypeScript",
        color: "blue-500",
      },
      {
        name: "FastAPI",
        color: "purple-200",
      },
      {
        name: "Supabase",
        color: "orange-200",
      },
      {
        name: "PostgreSQL",
        color: "blue-800",
      },

      {
        name: "AWS Amplify",
        color: "green-500",
      },

      {
        name: "CI/CD",
        color: "pink-400",
      },
      {
        name: "Gemini API",
        color: "indigo-400",
      },
      {
        name: "OpenAI API",
        color: "green-600",
      },
    ],
    img: require("../assets/images/MOOD.png"),
    link: "https://mood-tracker-rosy.vercel.app/",
    code: "https://github.com/khmorad/Mood-Tracker",
  },
  {
    title: "Genescope",
    desc: "A full-stack AI platform that analyzes gene expression and clinical data to predict breast cancer stages. Utilizes statistical techniques like PCA and AHP alongside machine learning models such as Random Forest, CatBoost, and neural networks for biomarker ranking and classification. Features a responsive Next.js frontend, a Flask backend for model inference, and an AI chatbot powered by LangChain and OpenAI for interactive insights and Chart.js visualizations. Deployed with Docker on Google Cloud for scalable, production-ready performance.",
    tags: [
      {
        name: "Next.js",
        color: "blue-200",
      },
      {
        name: "Flask",
        color: "purple-200",
      },
      {
        name: "OpenAI API",
        color: "green-600",
      },
      {
        name: "Lang Chain",
        color: "yellow-200",
      },
    ],
    img: aiassist,
    link: "https://gene-scope.vercel.app",
    code: "https://github.com/khmorad/GeneScope",
  },

  {
    title: "Clothing Recommender",
    desc: "A web application that uses advanced machine learning to help users find clothing items that match their style. When users upload an image, the app processes it through a deep Convolutional Neural Network (CNN), specifically ResNet50, to extract detailed visual features such as patterns, textures, and colors. These features are then embedded into a high-dimensional vector space. The webapp compares the vector of the uploaded image with those in its extensive database of clothing items, using cosine similarity to measure how closely they match. It then presents the user with the top 10 most similar items.",
    tags: [
      {
        name: "React.js",
        color: "blue-400",
      },
      {
        name: "Flask",
        color: "purple-200",
      },
      {
        name: "MySql",
        color: "orange-300",
      },
      {
        name: "Machine Learning",
        color: "blue-800",
      },
    ],
    img: clothing_recommender,
    link: "https://www.youtube.com/watch?v=P2Y8-JbCPIk",
    code: "https://github.com/khmorad/clothingRecommendationApp",
  },
  {
    title: "Car Dealership Management System",
    desc: "comprehensive car dealership management system integrating React for a seamless frontend, Flask for backend connectivity to MySQL, an OpenAI API-powered chatbot for customer assistance, and a login system with specialized employee dashboards for administrative purposes.",
    tags: [
      {
        name: "React.js",
        color: "blue-400",
      },
      {
        name: "Flask",
        color: "purple-200",
      },
      {
        name: "OpenAI API",
        color: "green-600",
      },
      {
        name: "Google Cloud SQL",
        color: "orange-100",
      },
    ],
    img: car,
    link: "https://www.youtube.com/watch?v=VmVytncY6dc",
    code: "https://github.com/khmorad/Car_Dealership_Management_System",
  },
  {
    title: "recepieMakerAI",
    desc: "RecipeMakeAI is a web application that enables users to generate recipes by inputting ingredients through a search bar or uploading images for ingredient detection. Utilizing Flask for the backend, TensorFlow for object detection, and the OpenAI API for estimating preparation time and calorie counts, the app offers a comprehensive recipe generation experience. The recipes are fetched from the Edamam API, ensuring a diverse and extensive recipe database. The frontend is built with React, providing a user-friendly interface, while additional functionalities are enhanced using HTML, CSS, and JavaScript.",
    tags: [
      {
        name: "React.js",
        color: "blue-400",
      },
      {
        name: "Flask",
        color: "purple-200",
      },
      {
        name: "MySql",
        color: "orange-300",
      },
      {
        name: "Machine Learning",
        color: "blue-800",
      },
    ],
    img: "https://d112y698adiu2z.cloudfront.net/photos/production/software_photos/002/931/214/datas/gallery.jpg",
    link: "https://recepie-maker-ai.vercel.app",
    code: "https://github.com/khmorad/recepieMakerAI",
  },
  {
    title: "CodeAssistAI",
    desc: "An intelligent debugging tool that scans uploaded project files, detects errors, and provides detailed reports with precise locations and suggestions. Featuring a smooth React.js interface and multi-file support, it streamlines the debugging process and reduces development time by up to 40%, offering a faster and more efficient coding experience.",
    tags: [
      {
        name: "React.js",
        color: "blue-400",
      },
      {
        name: "OpenAI API",
        color: "green-600",
      },
      {
        name: "Django",
        color: "purple-300",
      },
    ],
    img: codeassist,
    link: "https://code-assist-ai.vercel.app/",
    code: "https://github.com/khmorad/code-assist-ai",
  },
  {
    title: "github porfile explorer",
    desc: "comprehensive car dealership management system integrating React for a seamless frontend, Flask for backend connectivity to MySQL, an OpenAI API-powered chatbot for customer assistance, and a login system with specialized employee dashboards for administrative purposes.",
    tags: [
      {
        name: "Flask",
        color: "purple-200",
      },
      {
        name: "OpenAI API",
        color: "green-600",
      },
      {
        name: "Github API",
        color: "black-200",
      },
    ],
    img: github,
    link: "https://github.com/khmorad/git_profile_explorer",
    code: "https://github.com/khmorad/git_profile_explorer",
  },
  {
    title: "E-commerce Data Analysis Dashboard",
    desc: "A Python application that uses the Axesso API to fetch Walmart product data and present it through a clean, Figma-inspired interface. It processes real-time data using Pandas and visualizes insights with Matplotlib and Seaborn, offering interactive keyword-based analysis through features like correlation matrices and scatter plots ideal for tracking trends and making informed business decisions.",
    tags: [
      {
        name: "Python",
        color: "red-600",
      },
      {
        name: "Pandas",
        color: "green-800",
      },
      {
        name: "matplotlib",
        color: "orange-300",
      },
      {
        name: "seaborn",
        color: "grey-300",
      },
    ],
    img: Eccomerence,
    link: "https://github.com/khmorad/E_Commerce_Dashboard",
    code: "https://github.com/khmorad/E_Commerce_Dashboard",
  },

  {
    title: "Algorithm Visualizer",
    desc: "An interactive tool that visually demonstrates how sorting algorithms like Bubble Sort, Insertion Sort, Merge Sort, and Quick Sort work. Users can adjust array size and speed to watch step-by-step animations, making it easier to understand and compare algorithm behavior. Designed to be both educational and visually engaging.",
    tags: [
      {
        name: "React.js",
        color: "blue-400",
      },
      {
        name: "JavaScript",
        color: "orange-500",
      },
    ],
    img: visualizer,
    link: "https://algorithm-visualizer-ashy.vercel.app/",
    code: "https://github.com/khmorad/algorithm-visualizer",
  },

  {
    title: "Library Management System",
    desc: " a robust Java-based application aimed at digitizing and streamlining library operations. Featuring a user-friendly interface built with Java Swing, this system empowers librarians with complete administrative control, enabling CRUD operations for managing various library items like books, theses, and video tapes. Leveraging a persistent' database using JSON files, the system ensures data retention even after the application is closed.",
    tags: [
      {
        name: "Java",
        color: "orange-900",
      },
    ],
    img: "https://raw.githubusercontent.com/khmorad/CS151_Library_Management_System/main/project-report/image.png",
    link: "https://github.com/khmorad/CS151_Library_Management_System",
    code: "https://github.com/khmorad/CS151_Library_Management_System",
  },

  {
    title: "Stock Prediction Experiment",
    desc: "A python program design to use machiene learning models like linear regression and Long Short-Term Memory to predict stocks ",
    tags: [
      {
        name: "python",
        color: "red-600",
      },
      {
        name: "pandas",
        color: "green-800",
      },
      {
        name: "Machine Learning",
        color: "blue-800",
      },
      {
        name: "polygon API",
        color: "green-200",
      },
    ],
    img: "https://cdn.dribbble.com/users/1330777/screenshots/15577912/media/3441c6b4d1427a5e54d2b53607891a71.gif",
    link: "https://github.com/khmorad/stock_pridiction_experiment",
    code: "https://github.com/khmorad/stock_pridiction_experiment",
  },

  {
    title: "Cisco Sextant Dashboard",
    desc: "Created dashboard which uses Node.js and React.js that provides all the relevent information about current device being used.",
    tags: [
      {
        name: "React.js",
        color: "blue-400",
      },
      {
        name: "Node.js",
        color: "green-600",
      },
      {
        name: "ipify API",
        color: "yellow-600",
      },
    ],
    img: sextant,
    link: "https://www.youtube.com/watch?v=YtyWXA_kwBk&ab_channel=khashayarmoradpour",
    code: "https://github.com/khmorad/cisco_sextant_tasks",
  },
];

/*
  {
    title: "Data Analysis (stackoverflow experiment)",
    desc: "By using python this project demonstrates my ability to manipulate and analyze data effectively, extract meaningful conclusions, and visualize findings for a broader audience. By leveraging the power of Pandas, I've explored various aspects of the survey data, uncovering valuable information that can shed light on the developer landscape.",
    tags: [
      {
        name: "Python",
        color: "red-600",
      },
      {
        name: "pandas",
        color: "green-800",
      },
      {
        name: "numpy",
        color: "yellow-600",
      },
    ],
    img: "https://cdn.stackoverflow.co/images/jo7n4k8s/production/01318ce55cab0d508bd88b6ec5610ec1c659060a-2400x1260.png?w=1200&h=630&auto=format&dpr=2",
    link: "https://github.com/khmorad/stackoverflow_data_analysis",
    code: "https://github.com/khmorad/stackoverflow_data_analysis",
  },
*/
